import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const HeroBanner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 text-shadow-black text-shadow-md">
          {t("hero.title1")}
          <br /> {t("hero.title2")}
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto text-shadow-md">
          {t("hero.subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={() => navigate("/lists")} className="btn">
            {t("buttons.create_your_list")}
          </button>
          <button onClick={() => navigate("/lists")} className="btn-alt">
            {t("buttons.explore_rankings")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
